import { Context } from '@nuxt/types';
import EligibilityModule from '~/store/eligibility';
import { Settings } from '~/services/settings';

/**
 * Guards the patient-information pages. The path question (and the eligibility answers)
 * are only written to the eligibility store when the eligibility page is submitted, and
 * that store is in-memory only (not persisted - see store/index.ts). If a user reaches
 * patient-information without completing eligibility in this session - e.g. a page refresh
 * or a deep link - the subsequent fullSurveySession would be sent without the path value.
 * Detect that by checking for the path question and send the user back to the start.
 */
export default function(context: Context) {
    const eligibility = context.container.get(EligibilityModule);
    const settings = context.container.get(Settings);
    const hasPathAnswer = eligibility.eligibilityData.some(
        question => question.questionId === Number(settings.pathQuestion)
    );
    if (!hasPathAnswer) {
        context.redirect({ name: 'index' });
    }
}
